<owl-carousel-o id="principal" #owlCarousel [options]="customOptions" class="image-slider">
    @for (image of images; track image) {
    <ng-template id="{{$index}}" carouselSlide>
        <img class="w-full" [src]="image.previewImageSrc" [alt]="image.alt"/>
    </ng-template>
    }
</owl-carousel-o>

<div class="w-full h-full bg-zinc-700">
        <owl-carousel-o id="secondary" [options]="customOptions2" class="image2-slider">
            @for (image of images; track image) {
            <ng-template [id]="image.previewImageSrc" carouselSlide>
                <img [src]="image.previewImageSrc" (click)="goToSlide($index)"
                    class="!h-[100px] aspect-video !w-auto my-4 cursor-pointer" [alt]="image.alt" />
            </ng-template>
            }
        </owl-carousel-o>
</div>

